export const DocFlowTableName = {
  Combining: 'document-stapling-combinings',
  List: 'document-staplings',
  MappingResult: 'document-stapling-uploading-results',
  RequestConnected: 'request-connected-document-staplings',
  Result: 'document-stapling-results',
  Sending: 'document-stapling-sendings',
  Uploading: 'document-stapling-uploadings',
}

export const DOC_FLOW_REQUEST_LINKS_MAX_COUNT = 100

export const DocFlowRequestLinksServerError = {
  AlreadyConnected: 'Document_stapling_and_request_are_already_connected',
  LimitExceeded: 'Document_stapling_request_links_limit_exceeded',
}

export const DocFlowRequestLinksField = {
  DocFlowConnectedRequests: 'connected_requests',
  DocFlowConnectedRequestsCount: 'connected_requests_count',
  DocFlowRequestIds: 'request_ids',
  RequestDocFlowIds: 'document_stapling_ids',
}

export const DocFlowTableCellName = {
  Archived: 'archived',
  Completed: 'completed',
  CompletedBy: 'completed_by',
  ConnectedRequests: DocFlowRequestLinksField.DocFlowConnectedRequests,
  Created: 'created',
  CreatedBy: 'created_by',
  DocumentsCount: 'documents_count',
  EpostSpentCredits: 'epost_spent_credits',
  Name: 'name',
  Phase: 'phase',
  Status: 'status',
  Updated: 'updated',
  UpdatedBy: 'updated_by',
}

// Indexes of DOC_FLOW_STATUSES, as the backend sends them.
export const DocFlowStatus = {
  Completed: 2,
  InProgress: 1,
  Pending: 0,
}

export const DOC_FLOW_OPEN_STATUSES = [
  DocFlowStatus.Pending,
  DocFlowStatus.InProgress,
]

export const DOC_FLOW_PRE_FILTER = {
  open: 'open',
}

export const DOC_FLOW_STATUSES = [
  {
    text: 'DocumentStaplingTable.PendingStatusKey',
    textColor: 'var(--color-error)',
  },
  {
    text: 'DocumentStaplingTable.InProgressStatusKey',
    textColor: 'var(--color-in-progress)',
  },
  {
    text: 'DocumentStaplingTable.CompletedStatusKey',
    textColor: 'var(--color-success)',
  },
]

// Indexed by the phase the backend sends, like DOC_FLOW_STATUSES above.
export const DOC_FLOW_PHASE_TITLE_KEYS = [
  'DocumentStapling.PhaseUploadingKey',
  'DocumentStapling.PhaseSplittingKey',
  'DocumentStapling.PhaseCombiningKey',
  'DocumentStapling.PhaseSavingKey',
  'DocumentStapling.PhaseResultKey',
]

export const DOC_FLOW_RESULT_EMAIL_STATUS_FILTER_NAME = 'email_status'

export const DOC_FLOW_RESULT_EPOST_STATUS_FILTER_NAME = 'epost_status'

export const DOC_FLOW_RESULT_SAVED_TO_PROFILE_STATUS_FILTER_NAME =
  'saved_to_profile_status'

export const DOC_FLOW_RESULT_SAVE_TO_PROFILE_STATUS = {
  saved: 0,
}

export const DOC_FLOW_RESULT_SEND_EMAIL_STATUS = {
  error: 2,
  sending: 1,
  sent: 0,
}

export const DOC_FLOW_RESULT_SEND_EPOST_STATUS = {
  canceled: 5,
  error: 6,
  preparation: 0,
  printProcess: 3,
  production: 2,
  sent: 4,
  shippable: 1,
}

// Binect status codes as sent by the backend → DOC_FLOW_RESULT_SEND_EPOST_STATUS
export const DOC_FLOW_RESULT_EPOST_STATUS_BY_CODE = {
  1: DOC_FLOW_RESULT_SEND_EPOST_STATUS.preparation,
  2: DOC_FLOW_RESULT_SEND_EPOST_STATUS.shippable,
  3: DOC_FLOW_RESULT_SEND_EPOST_STATUS.production,
  4: DOC_FLOW_RESULT_SEND_EPOST_STATUS.printProcess,
  5: DOC_FLOW_RESULT_SEND_EPOST_STATUS.sent,
  6: DOC_FLOW_RESULT_SEND_EPOST_STATUS.canceled,
  7: DOC_FLOW_RESULT_SEND_EPOST_STATUS.error,
}

export const DOC_FLOW_RESULT_SAVE_TO_PROFILE_STATUSES = [
  {
    text: 'DocumentStapling.SaveToProfileStatusKey',
    textColor: 'var(--color-success)',
  },
]

export const DOC_FLOW_RESULT_EMAIL_STATUSES = [
  {
    text: 'DocumentStapling.EmailStatusSentKey',
    textColor: 'var(--color-success)',
  },
  {
    text: 'DocumentStapling.EmailStatusSendingKey',
    textColor: 'var(--color-info)',
  },
  {
    text: 'DocumentStapling.EmailStatusErrorKey',
    textColor: 'var(--color-error)',
  },
]

export const DOC_FLOW_RESULT_EPOST_STATUSES = [
  {
    text: 'DocFlow.EpostStatusPreparationKey',
    textColor: 'var(--secondary-text-color)',
  },
  {
    text: 'DocFlow.EpostStatusShippableKey',
    textColor: 'var(--secondary-text-color)',
  },
  {
    text: 'DocFlow.EpostStatusProductionKey',
    textColor: 'var(--secondary-text-color)',
  },
  {
    text: 'DocFlow.EpostStatusPrintProcessKey',
    textColor: 'var(--secondary-text-color)',
  },
  {
    text: 'DocFlow.EpostStatusSentKey',
    textColor: 'var(--color-success)',
  },
  {
    backgroundColor: 'var(--color-error)',
    text: 'DocFlow.EpostStatusCanceledKey',
    textColor: 'var(--color-white)',
  },
  {
    text: 'DocFlow.EpostStatusErrorKey',
    textColor: 'var(--color-error)',
  },
]

export const DOC_FLOW_RESULT_STATUS_FILTER_CONFIG = {
  [DOC_FLOW_RESULT_EMAIL_STATUS_FILTER_NAME]: {
    statuses: DOC_FLOW_RESULT_EMAIL_STATUSES,
    statusIds: DOC_FLOW_RESULT_SEND_EMAIL_STATUS,
  },
  [DOC_FLOW_RESULT_EPOST_STATUS_FILTER_NAME]: {
    statuses: DOC_FLOW_RESULT_EPOST_STATUSES,
    statusIds: DOC_FLOW_RESULT_EPOST_STATUS_BY_CODE,
  },
  [DOC_FLOW_RESULT_SAVED_TO_PROFILE_STATUS_FILTER_NAME]: {
    statuses: DOC_FLOW_RESULT_SAVE_TO_PROFILE_STATUSES,
    statusIds: DOC_FLOW_RESULT_SAVE_TO_PROFILE_STATUS,
  },
}
